import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Frontend code must only use the public anon key. Admin reads and writes depend on
// Supabase Auth plus database RLS policies, never a service role key in React.
export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey
);
